// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"oT","innerWrapper":"pT","tooltipWrapper":"qT","tooltip":"rT","content":"sT"};